import { Link } from 'react-router-dom';
import { Card, CardContent } from '../components/ui/card';
import { BarChart3, PieChart, ArrowRight, TrendingUp } from 'lucide-react';

export default function AnalyticsHubPage() {
  const cards = [
    {
      to: '/statistiche',
      label: 'Statistiche',
      desc: 'KPI, grafici e funnel preventivi → fatture (real-time)',
      icon: BarChart3,
      color: 'cyan',
      testid: 'hub-card-statistiche',
    },
    {
      to: '/reports',
      label: 'Reports',
      desc: 'Report personalizzabili: vendite, interventi, magazzino, fatturato',
      icon: PieChart,
      color: 'violet',
      testid: 'hub-card-reports',
    },
  ];

  return (
    <div className="space-y-6" data-testid="analytics-hub">
      <div className="flex items-start gap-3">
        <div className="h-12 w-12 rounded-md bg-cyan-500/10 text-cyan-600 flex items-center justify-center">
          <TrendingUp className="h-6 w-6" />
        </div>
        <div>
          <h1 className="text-2xl font-black tracking-tight">Analytics</h1>
          <p className="text-sm text-muted-foreground">KPI in tempo reale e reportistica avanzata</p>
        </div>
      </div>

      <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
        {cards.map(c => {
          const Icon = c.icon;
          const colorMap = {
            cyan: 'border-cyan-500/40 bg-cyan-500/5',
            violet: 'border-violet-500/40 bg-violet-500/5',
          };
          return (
            <Link to={c.to} key={c.to} data-testid={c.testid}>
              <Card className={`hover:shadow-lg transition-all hover:-translate-y-0.5 cursor-pointer border-l-4 ${colorMap[c.color]}`}>
                <CardContent className="p-6">
                  <div className="flex items-start justify-between mb-4">
                    <div className={`h-12 w-12 rounded-md bg-${c.color}-500/10 flex items-center justify-center`}>
                      <Icon className={`h-6 w-6 text-${c.color}-500`} />
                    </div>
                    <ArrowRight className="h-5 w-5 text-muted-foreground" />
                  </div>
                  <h3 className="font-bold text-xl tracking-tight">{c.label}</h3>
                  <p className="text-sm text-muted-foreground mt-2">{c.desc}</p>
                </CardContent>
              </Card>
            </Link>
          );
        })}
      </div>
    </div>
  );
}
